import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Filter, defaultFiler, filteredTasksSelector, taglineSelector, fields, _MainChart, _Homepage} from '../components/LookAhead'
import {statusDateSelector} from '../selectors/dataset'
import {settings_set_use_status_date} from '../actions/settings'
import {useStatusDateSelector} from '../selectors/settings'

let mapStateToProps = state => ({
  use_status_date: useStatusDateSelector(state)
})

let mapDispatchToProps = dispatch => ({
    onSetUseStatusDate: flag => dispatch(settings_set_use_status_date(flag))
})

export let MainChart = connect(mapStateToProps, mapDispatchToProps)(_MainChart)

export let Homepage = connect(mapStateToProps, mapDispatchToProps)(_Homepage)

export {Filter, defaultFiler, filteredTasksSelector, taglineSelector, fields}



// class StatefulLookAhead extends Component
// {
//   constructor(props)
//   {
//     super(props)
//     this.state = {
//       useStatusDate: false
//     }
//   }

//   onSetUseStatusDate = (event, useStatusDate) =>
//   {
//     this.setState({useStatusDate})
//   }
  

//   render()
//   {    
//     return (
//     <LookAhead 
//       use_status_date={this.state.useStatusDate}
//       onSetUseStatusDate={this.onSetUseStatusDate}
//       current_filter={Filter.none}
//       {...this.props}
//     />)
//   }
// }

// StatefulLookAhead.wrappedComponent = LookAhead
// StatefulLookAhead.propTypes = {
//   ...LookAhead.propTypes,
// }



// export default StatefulLookAhead




// WEBPACK FOOTER //
// ./src/containers/LookAhead.js